import { render, staticRenderFns } from "./returnRent.vue?vue&type=template&id=bfff2aec&"
import script from "./returnRent.vue?vue&type=script&lang=js&"
export * from "./returnRent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfff2aec')) {
      api.createRecord('bfff2aec', component.options)
    } else {
      api.reload('bfff2aec', component.options)
    }
    module.hot.accept("./returnRent.vue?vue&type=template&id=bfff2aec&", function () {
      api.rerender('bfff2aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/leaseContract/contractList/returnRent.vue"
export default component.exports